module.exports = __webpack_public_path__ + "background-login.b8063e6e68581c9093b2.jpg";


//////////////////
// WEBPACK FOOTER
// D:/Work-Local/frontend/src/assets/images/default/background-login.jpg
// module id = ../../../../../src/assets/images/default/background-login.jpg
// module chunks = main